var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/help-navigation/section-header.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/navigation-items.j2", false, "help/templates/help-navigation/section-header.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderNavItem")) {
var t_4 = t_1.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_4);
output += "\n\n";
output += runtime.suppressValue((lineno = 2, colno = 49, runtime.callWrap(t_4, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "sectionHeaderNavItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_5 = runtime.makeMacro(
["navItemToRender", "url", "target"], 
[], 
function (l_navItemToRender, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItemToRender", l_navItemToRender);
frame.set("url", l_url);
frame.set("target", l_target);
var t_6 = "";t_6 += "\n\n    ";
var t_7;
t_7 = runtime.memberLookup((l_navItemToRender),"typeCode");
frame.set("navType", t_7, true);
if(frame.topLevel) {
context.setVariable("navType", t_7);
}
if(frame.topLevel) {
context.addExport("navType", t_7);
}
t_6 += "\n    ";
var t_8;
t_8 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"slug") == runtime.memberLookup((l_navItemToRender),"slug")?" o-secondary-navigation__a--current":"");
frame.set("helpSelectedClass", t_8, true);
if(frame.topLevel) {
context.setVariable("helpSelectedClass", t_8);
}
if(frame.topLevel) {
context.addExport("helpSelectedClass", t_8);
}
t_6 += "\n    ";
var t_9;
t_9 = "noopener noreferrer";
frame.set("rel", t_9, true);
if(frame.topLevel) {
context.setVariable("rel", t_9);
}
if(frame.topLevel) {
context.addExport("rel", t_9);
}
t_6 += "\n\n    <h2 class=\"o-secondary-navigation__h2 ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
t_6 += " js-dropdown-toggle ";
;
}
t_6 += "\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "navType") == "HEADING") {
t_6 += "\n            ";
t_6 += runtime.suppressValue(runtime.memberLookup((l_navItemToRender),"displayName"), env.opts.autoescape);
t_6 += "\n        ";
;
}
else {
t_6 += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"slug") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"navRootSlug") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
t_6 += "\n                <span class=\"o-secondary-navigation__a o-secondary-navigation__a--parent-category js-secondary-navigation__a\">";
t_6 += runtime.suppressValue(runtime.memberLookup((l_navItemToRender),"displayName"), env.opts.autoescape);
t_6 += "</span>\n            ";
;
}
else {
t_6 += "\n                <a class=\"o-secondary-navigation__a o-secondary-navigation__a--parent-category ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "helpSelectedClass"), env.opts.autoescape);
t_6 += " js-secondary-navigation__a\" ";
if(l_target) {
t_6 += " target=\"";
t_6 += runtime.suppressValue(l_target, env.opts.autoescape);
t_6 += "\" ";
if(l_target == "_blank") {
t_6 += " rel=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_6 += "\" ";
;
}
t_6 += " ";
;
}
t_6 += " href=\"";
t_6 += runtime.suppressValue(l_url, env.opts.autoescape);
t_6 += "\">";
t_6 += runtime.suppressValue(runtime.memberLookup((l_navItemToRender),"displayName"), env.opts.autoescape);
t_6 += "</a>\n            ";
;
}
t_6 += "\n        ";
;
}
t_6 += "\n    </h2>\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_6);
});
return macro_t_5;})()})])), env.opts.autoescape);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/help-navigation/section-header.j2"] , dependencies)